import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { auth } from "./firebase";
import logo from "./assets/wgwitlogov1white-02.png";

function HamburgerMenu({ menuOpen, toggleMenu }) {
  const navigate = useNavigate();
  const location = useLocation();
  const menuRef = useRef(null);
  const [user, setUser] = useState(null);

  const menuLinks = [
    { label: "Home", route: "/" },
    { label: "Pricing", route: "/pricing" },
    { label: "What We Evaluate", route: "/what-we-evaluate" },
    { label: "FAQs", route: "/faqs" },
    { label: "Contact", route: "/contact" },
    { label: "Terms of Service", route: "/terms-of-service" },
  ];

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        toggleMenu(false);
      }
    }

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen, toggleMenu]);

  const handleLogout = async () => {
    await auth.signOut();
    toggleMenu(false);
    navigate("/login");
  };

  return (
    <>
      {/* Desktop: Logo image + text (top-left) */}
      <div
        className="fixed top-4 left-6 z-[2000] items-center gap-3 cursor-pointer hidden sm:flex"
        onClick={() => navigate("/")}
      >
        <img src={logo} alt="Logo" className="h-8 w-8 object-contain" />
        <span className="text-white text-xl font-bold font-[Montserrat]">
          pregradepros.com
        </span>
      </div>

      {/* Mobile: Left logo image */}
      <div
        className="fixed top-4 left-4 z-[2000] sm:hidden cursor-pointer"
        onClick={() => navigate("/")}
      >
        <img src={logo} alt="Logo" className="h-8 w-8 object-contain" />
      </div>

      {/* Mobile: Centered text logo, hidden on landing page */}
      {location.pathname !== "/" && (
        <div
          className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[2000] sm:hidden cursor-pointer"
          onClick={() => navigate("/")}
        >
          <span className="text-white text-xl font-bold font-[Montserrat]">
            pregradepros.com
          </span>
        </div>
      )}

      {/* Top Right Hamburger Icon */}
      <button
        onClick={toggleMenu}
        style={{
          fontSize: "28px",
          background: "none",
          border: "none",
          cursor: "pointer",
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 2000,
          color: "white",
        }}
        aria-label="Open navigation menu"
      >
        <FaBars />
      </button>

      {/* Dropdown menu */}
      {menuOpen && (
        <div
          ref={menuRef}
          style={{
            position: "fixed",
            top: "64px",
            right: "20px",
            backgroundColor: "#15151a",
            border: "1px solid #333",
            padding: "16px",
            boxShadow: "0 6px 32px rgba(0,0,0,0.28)",
            zIndex: 2100,
            borderRadius: "12px",
            minWidth: "220px",
          }}
        >
          {menuLinks.map((item) => (
            <p
              key={item.label}
              onClick={() => {
                navigate(item.route);
                toggleMenu(false);
              }}
              style={{
                margin: "0 0 12px 0",
                cursor: "pointer",
                padding: "8px 0",
                color: "#eaeaea",
                fontSize: "1.06rem",
                borderRadius: "6px",
                transition: "background 0.16s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = "#232333")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.background = "none")
              }
            >
              {item.label}
            </p>
          ))}

          {user ? (
            <p
              onClick={handleLogout}
              style={{
                margin: "0",
                cursor: "pointer",
                padding: "8px 0",
                color: "#ff4d4d",
                fontSize: "1.06rem",
                borderRadius: "6px",
                transition: "background 0.16s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = "#232333")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.background = "none")
              }
            >
              Logout
            </p>
          ) : (
            <>
              <p
                onClick={() => {
                  navigate("/login");
                  toggleMenu(false);
                }}
                style={{
                  margin: "0 0 12px 0",
                  cursor: "pointer",
                  padding: "8px 0",
                  color: "#3b82f6",
                  fontWeight: "600",
                  fontSize: "1.06rem",
                  borderRadius: "6px",
                  transition: "background 0.16s, color 0.16s",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = "#232333";
                  e.currentTarget.style.color = "#60a5fa";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "none";
                  e.currentTarget.style.color = "#3b82f6";
                }}
              >
                Login
              </p>
              <p
                onClick={() => {
                  navigate("/signup");
                  toggleMenu(false);
                }}
                style={{
                  margin: "0",
                  cursor: "pointer",
                  padding: "8px 0",
                  color: "#3b82f6",
                  fontWeight: "600",
                  fontSize: "1.06rem",
                  borderRadius: "6px",
                  transition: "background 0.16s, color 0.16s",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = "#232333";
                  e.currentTarget.style.color = "#60a5fa";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "none";
                  e.currentTarget.style.color = "#3b82f6";
                }}
              >
                Sign Up
              </p>
            </>
          )}
        </div>
      )}
    </>
  );
}

export default HamburgerMenu;